$('[data-thumbnail-color]').addClass("thumb-hidden");


// function removeThumbHiddenClass(){
//     var color = $(this).attr('data-option-value');
//     $('img').each(function(){
//         if($(this).attr('alt') === color){
//             $(this).removeClass('thumb-hidden');
//         }
//     });
// }
var color = $('img').attr('data-product-color');
console.log(color);

var thumbnail_selector = $('[data-thumbnail-color="' + selected_color + '"]');
thumbnail_selector.removeClass("thumb-hidden");



$(document).ready(function(){
    // Tu código aquí
    $('.swatch').hover(function(){
        var color = $(this).attr('data-option-value');
        $('img').each(function(){
            if($(this).attr('alt') === color){
                $(this).removeClass('thumb-hidden');
            }
        });
    }, function(){
      //aqui podrías poner código para ejecutar al salir del hover
    });
  });
  
  
  function changeImage(clickedSwatch) {
    var productColor = clickedSwatch.getAttribute('data-option-value');
    console.log('productColor:', productColor);
  
    // Oculta todas las imágenes
    var allImages = document.querySelectorAll('[data-alt-color]');
    allImages.forEach(function(image) {
      image.classList.add('thumb-hidden-pdp');
    });
  
    // Muestra solo las imágenes que contienen el color seleccionado
    var imagesToShow = document.querySelectorAll(`[alt*="${productColor}"]`);
    imagesToShow.forEach(function(image) {
      image.classList.remove('thumb-hidden-pdp');
    });
  };
  
  
  function changeImagePLP(clickedSwatch) {
    var productColor = clickedSwatch.getAttribute('data-option-value');
    var productId = clickedSwatch.getAttribute('data-product-id');
    var image = document.querySelector(`[data-thumbnail-color="${productColor}"]`);
    var image_two = document.querySelector(`[data-mi-atributo="${productId}"]`);

    if ( image.alt === productColor ) {
        image.classList.remove('thumb-hidden');
        if( image_two.id === productId ){
            image_two.classList.add('thumb-hidden');
         
        }
    }
  };


  function outImage(clickedSwatch) {
    var productColor = clickedSwatch.getAttribute('data-option-value');
    var productId = clickedSwatch.getAttribute('data-product-id');
    var image = document.querySelector(`[data-thumbnail-color="${productColor}"]`);
    var image_two = document.querySelector(`[data-mi-atributo="${productId}"]`);


    if ( image.alt === productColor ) {
        image.classList.add('thumb-hidden');
        if( image_two.id === productId ){
            image_two.classList.remove('thumb-hidden');
         
        }
    }
  };